export default function (count = 10) {
  // @vue/component
  return {
    data () {
      return {
        displayPriority: 0
      }
    },

    methods: {
      runDisplayPriority () {
        const step = () => {
          requestAnimationFrame(() => {
            this.displayPriority++
            if (this.displayPriority < count) {
              step()
            }
          })
        }
        step()
      },

      defer (priority) {
        // console.log('defer works here - ', priority)
        return this.displayPriority >= priority
      }
    },

    mounted () {
      this.runDisplayPriority()
    }
  }
}
